// Search grammar v1. Keep frontend/API adapters aligned through the shared contract cases.
const normalizeSearch = value => String(value ?? '').normalize('NFKC').toLowerCase()
function parseSearch(value, allowAnchors = true) {
  const query = normalizeSearch(value).trim()
  const start = allowAnchors && query.startsWith('^'), end = allowAnchors && query.endsWith('$')
  const body = query.slice(start ? 1 : 0, end ? -1 : undefined)
  const parts = body.split(/(\.\*|\.\+)/).filter(Boolean)
  return {query, body, start, end, parts}
}
function hasSearchModifiers(value) {
  const p = parseSearch(value)
  return p.start || p.end || p.parts.some(part => part === '.*' || part === '.+')
}
function patternMatcher(value, allowAnchors = true) {
  const p = parseSearch(value, allowAnchors)
  // Use a glob matcher, not user-provided regular expressions or exponential regex backtracking.
  const tokens = [...(p.start ? [] : [null]), ...p.parts.flatMap(part => part === '.*' ? [null] : part === '.+' ? [undefined, null] : [...part]), ...(p.end ? [] : [null])]
  return value => {
    const text = [...normalizeSearch(value)]
    let i = 0, j = 0, star = -1, retry = 0
    while (i < text.length) {
      if (j < tokens.length && tokens[j] !== null && (tokens[j] === undefined || tokens[j] === text[i])) {i++; j++}
      else if (j < tokens.length && tokens[j] === null) {star = j++; retry = i}
      else if (star >= 0) {j = star + 1; i = ++retry}
      else return false
    }
    while (j < tokens.length && tokens[j] === null) j++
    return j === tokens.length
  }
}
function compileSearch(query) {
  const p = parseSearch(query)
  if (!p.query) return () => true
  const whole = patternMatcher(p.query)
  const terms = p.start || p.end ? [] : p.query.split(/\s+/).map(term => patternMatcher(term, false))
  return values => {
    const fields = (Array.isArray(values) ? values : [values]).filter(value => value !== null && value !== undefined)
    return fields.some(whole) || (terms.length > 0 && terms.every(term => fields.some(term)))
  }
}
function matchesSearch(values, query) { return compileSearch(query)(values) }
function likePattern(value, allowAnchors = true) {
  const p = parseSearch(value, allowAnchors)
  return (p.start ? '' : '%') + p.parts.map(part => part === '.*' ? '%' : part === '.+' ? '_%' : part.replace(/[\\%_]/g, '\\$&')).join('') + (p.end ? '' : '%')
}

export {normalizeSearch, parseSearch, hasSearchModifiers, compileSearch, matchesSearch, likePattern}
